"use client"

import { useTranslations } from "next-intl"
import { useId } from "react"
import { RadioGroup, RadioGroupItem } from "@/components/originui/radio-group"

interface RecurringIntervalToggleProps {
  value: "month" | "year"
  onValueChange: (value: "month" | "year") => void
}

export function RecurringIntervalToggle({ value, onValueChange }: RecurringIntervalToggleProps) {
  const id = useId()
  const t = useTranslations()

  const handleValueChange = (newValue: string) => {
    if (newValue === "month" || newValue === "year") {
      onValueChange(newValue)
    }
  }

  return (
    <div className="inline-flex h-10 shrink-0 rounded-md bg-foreground/5 p-px transition-colors hover:bg-foreground/15! dark:bg-foreground/10">
      <RadioGroup
        value={value}
        onValueChange={handleValueChange}
        className="group relative inline-grid grid-cols-[1fr_1fr] items-center gap-0 font-medium text-sm after:absolute after:inset-y-0 after:w-1/2 after:rounded-md after:bg-background after:shadow-black/5 after:shadow-xs after:outline-offset-2 after:transition-transform after:duration-300 after:ease-in-out has-focus-visible:after:outline-2 has-focus-visible:after:outline-ring/70 data-[state=month]:after:translate-x-0 data-[state=year]:after:translate-x-full"
        data-state={value}
      >
        <label className="relative z-10 inline-flex h-full min-w-8 cursor-pointer select-none items-center justify-center whitespace-nowrap px-4 transition-colors group-data-[state=year]:text-muted-foreground">
          {t("Pricing.interval.month")}
          <RadioGroupItem id={`${id}-1`} value="month" className="sr-only" />
        </label>
        <label className="relative z-10 inline-flex h-full min-w-8 cursor-pointer select-none items-center justify-center whitespace-nowrap px-4 transition-colors group-data-[state=month]:text-muted-foreground">
          {t("Pricing.interval.year")}{" "}
          <span className="ml-2 text-emerald-500 transition-colors">{t("Pricing.discount")}</span>
          <RadioGroupItem id={`${id}-2`} value="year" className="sr-only" />
        </label>
      </RadioGroup>
    </div>
  )
}
